import { Tooltip } from "antd";
import type { ReactElement } from "react";
import { cloneElement } from "react";
import type { CustomerLimitGuardResult } from "./useCustomerLimitGuard";

interface CustomerLimitGuardedActionProps {
  limitGuard: CustomerLimitGuardResult;
  children: ReactElement<{ disabled?: boolean }>;
}

// Keep alert rendering outside this component so each screen controls its placement.
const CustomerLimitGuardedAction = ({
  limitGuard,
  children,
}: CustomerLimitGuardedActionProps) => (
  <Tooltip title={limitGuard.tooltip}>
    <span>
      {cloneElement(children, {
        disabled: Boolean(
          children.props.disabled || limitGuard.isLimitReached || limitGuard.isFetching
        ),
      })}
    </span>
  </Tooltip>
);

export default CustomerLimitGuardedAction;
